import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { DataService } from '@services/hiring-manger-profiledata.service';
import { GlobalErrorService } from '@services/global-error.service';
import { VendorEmployeeHeadCount, VendorHeadCountResponse } from '@interfaces/vendor-profile.model';
import { AuthService } from '@core/auth.service';
import { ActivatedRoute } from '@angular/router';
import { vendorProfileMetrics, VendorProfile, EmeraldLabel } from '@app/shared/constants/global.enum';

@Component({
  selector: 'app-contractor-vendor-head-count',
  templateUrl: './contractor-vendor-head-count.component.html',
  styleUrls: ['./contractor-vendor-head-count.component.scss'],
})
export class ContractorVendorHeadCountComponent implements OnInit {
  monthOptions: { value: string; label: string; month: string; year: string, selected?: boolean }[] = [];
  selectedMonth: string = '';
  selectedYear: string = '';
  totalCount: number = 0;
  isDataLoaded: boolean = false;
  errorMsg: string = '';
  displayData: VendorEmployeeHeadCount[] = [];
  employeeId: string | null = null;
  vendorName: string = '';
  @Input() selectedVendor: string | null = null;
  @Input() vendorId: string | null = null;
  contractorData: VendorEmployeeHeadCount | null = null;
  metrics: { label: string; key: keyof VendorEmployeeHeadCount; value?: number }[] = [
    { label: vendorProfileMetrics.TotalContractors, key: 'totalContractors' },
    { label: vendorProfileMetrics.HyderabadContractors, key: 'hyderabadContractors' },
    { label: vendorProfileMetrics.NcrContractors, key: 'ncrContractors' },
    { label: vendorProfileMetrics.RemoteContractors, key: 'remoteContractors' },
  ];
  vendorProfile = VendorProfile;
  emeraldLabel = EmeraldLabel;
  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private errorHandler: GlobalErrorService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // this.route.params.subscribe(params => {
    //   this.vendorName = decodeURIComponent(params['vendorName'] || '');
    // });
    this.vendorName = this.selectedVendor ?? '';
    this.generateLast12Months();

    const preSelectedOption = this.monthOptions.find(option => option.selected);
    if (preSelectedOption) {
      this.selectedMonth = preSelectedOption.month;
      this.selectedYear = preSelectedOption.year;
    }

    this.authService.getEmployeeDetails().then((employeeData: any) => {
      this.employeeId = employeeData?.employeeId || null;
      if (this.employeeId) {
        this.loadVendorData();
      }
    });
  }

  generateLast12Months(): void {
    const now = new Date();
    this.monthOptions = [];
    for (let i = 0; i < 12; i++) {
      const monthDate = new Date(now.getFullYear(), now.getMonth() - i);
      const monthLabel = monthDate.toLocaleString('default', { month: 'long', year: 'numeric' });
      const monthValue = `${(monthDate.getMonth() + 1).toString().padStart(2, '0')}, ${monthDate.getFullYear()}`;
      this.monthOptions.push({
        label: monthLabel,
        value: monthValue,
        month: (monthDate.getMonth() + 1).toString().padStart(2, '0'),
        year: monthDate.getFullYear().toString(),
        selected: i === 0,
      });
    }
  }

  loadVendorData(): void {
    if (!this.employeeId) return;
    this.dataService
      .getContractorHeadCountByVendor(this.employeeId, this.selectedMonth, this.selectedYear, this.vendorId ?? '')
      .subscribe({
        next: (response) => {
          const typedResponse = response as unknown as VendorHeadCountResponse;
          this.displayData = typedResponse.data || [];
          this.contractorData = this.displayData.length > 0 ? this.displayData[0] : null;
                    if (this.contractorData) {
            this.metrics = this.metrics?.map(metric => ({
              ...metric,
              value: this.contractorData![metric.key] as number
            }));
            this.totalCount = this.contractorData.totalContractors;
          } else {
            this.totalCount = 0;
          }
          
          this.isDataLoaded = true;
          this.cdr.detectChanges();
        },
        error: () => {
          this.errorMsg = VendorProfile.failedToLoadContractorHeadCount;
          this.isDataLoaded = true;
          this.displayData = [];
          this.contractorData = null;
          this.totalCount = 0;
          this.cdr.detectChanges();
        },
      });
  }

  onMonthChange(event: any): void {
    let selectedValue: string | undefined;

    if (typeof event === 'string') {
      const monthOption = this.monthOptions.find(option => option.label === event);
      selectedValue = monthOption ? monthOption.value : undefined;
    } else if (event.value) {
      selectedValue = event.value;
    }

    if (!selectedValue || !this.monthOptions.some(option => option.value === selectedValue)) {
     this.showError(VendorProfile.invalidMonthSelected);
      return;
    }

    const selectedOption = this.monthOptions.find(option => option.value === selectedValue);
    if (selectedOption) {
      this.selectedMonth = selectedOption.month;
      this.selectedYear = selectedOption.year;
      this.loadVendorData();
    }
  }

  private showError(message: string): void {
    alert(message);
  }
}
